import { FC } from 'react'
import { CalendarEvent } from '../../services/calendar'
import { durationLabel, eventBarClass, eventCardClass } from './calendar-layout'

interface CalendarEventRowProps {
  event: CalendarEvent
  onClick: (event: CalendarEvent) => void
}

/** Linha de evento do painel lateral do mês e da visão de agenda. */
const CalendarEventRow: FC<CalendarEventRowProps> = ({ event, onClick }) => (
  <button
    type="button"
    onClick={() => onClick(event)}
    className={`flex w-full items-start gap-3 rounded-lg border p-3 text-left text-sm transition hover:shadow-md ${eventCardClass(
      event.color,
    )}`}
  >
    <span className={`mt-0.5 w-1 shrink-0 self-stretch rounded ${eventBarClass(event.color)}`} />
    <div className="min-w-0 flex-1">
      <p className="truncate font-medium text-slate-700">{event.display_title}</p>
      <p className="mt-0.5 text-xs text-slate-500">
        {event.type_text}
        {event.is_flexible
          ? ` · ${durationLabel(event.duration_minutes)}`
          : event.starts_at
          ? ` · ${event.starts_at} – ${event.ends_at}`
          : ''}
      </p>
      {event.session_id && (
        <p className="mt-1 text-xs text-slate-500">
          Ensaio #{event.session_id}
          {event.client_name ? ` — ${event.client_name}` : ''}
        </p>
      )}
    </div>
  </button>
)

export default CalendarEventRow
